module.exports = __webpack_public_path__ + "img/Figure-10-3-min.ffa474a2.svg";